module.exports = __webpack_public_path__ + "52f4acef80f640f31459ed26ade1ee2b.svg";